<script lang="ts" setup>
import { useCompareDeckStore } from '@/store/compareDeck'
import { storeToRefs} from "pinia";
import { router, usePage } from "@inertiajs/vue3";
import { route } from "ziggy-js";
import { inject, computed, ref} from "vue";
import { onClickOutside } from '@vueuse/core';
import CloseIcon from "@icons/closeIcon.svg";
import TrashIcon from "@icons/trash-icon.svg";
import CarretsBlack from "@icons/carrets-black.svg";
import ProductPlaceholder from "@icons/product-placeholder.svg";

let dialogRef = inject("dialogRef");
let compareDeck = useCompareDeckStore()
let { products } = storeToRefs(compareDeck);

let productCount = computed(() => products.value.length);
let maxProducts = computed(() => 4);


let { removeProductFromDeck, clearDeck } = compareDeck;

let showComparisons = () => {
    close({ showComparisons: true})
    // router.push(route('compare'));
}

let close = ({ showComparisons }: { showComparisons: boolean}) => {
    dialogRef.value.close({ showComparisons });
}

let compareDrawer = ref();

onClickOutside(compareDrawer, () => {
    close({ showComparisons: false})
})

function clear(){
    clearDeck();
    close({ showComparisons: false})
}

function remove(product){
    //else if block needed for testing action for some reason
    if(removeProductFromDeck){
        removeProductFromDeck(product);
    }else if(compareDeck?._hmrPayload?.actions?.removeProductFromDeck){
        compareDeck._hmrPayload.actions.removeProductFromDeck(product);
    }
}

function addAProduct(event, index){
    if (event.target.closest('.compare-drawer__body--product-card__remove-btn')) return;
    else if(index-1 < productCount.value){
        router.visit(route('productDetail.show', [products.value[index-1]?.item?.seo_name]), {
            onSuccess(){
                close({showComparisons: false});
            }
        });
    } else {
        let productCodes = products.value.map(product=>product?.product_line_code).filter(code=>!!code) ?? [];
        router.visit(route('productDetail.boosted', { products: productCodes.join(","), boost_tag: 'similar' },), {
            onSuccess(){
                close({ showComparisons: false})
            }
        });
    }
}
</script>

<template>
    <div>
        <div :class="{
            'modal-overlay': true,
            'active': true
        }"></div>
        <div ref="compareDrawer" class="compare-drawer">
            <div class="compare-drawer__header">
                <div class="compare-drawer__header--text-content">
                    <h4 class="headline-s">Compare</h4>
                    <p class="paragraph-default">{{ productCount }} of {{ maxProducts}} Added</p>
                </div>
                <CloseIcon @click="close({ showComparisons: false})" class="compare-drawer__header--close" alt="Close Compare Drawer" aria-label="Close Compare Drawer" />
            </div>
            <div class="compare-drawer__body">
                <div @click="addAProduct($event, index)" v-for="index in maxProducts" :class="{'compare-drawer__body--product-card': true, 'empty-card': index-1 >= productCount}" :key="index">
                    <div v-if="index-1 < productCount" class="product-card-image-wrapper">
                        <img :src="products[index-1].primary_image" class="product-card-image" :alt="products[index-1].item_name" />
                        
                    </div>
                    <span v-if="index-1 < productCount" class="title-s">{{ products[index-1].item_name }}</span>

                    <div v-else-if="index-1 >= productCount" class="product-card-image-wrapper">
                        <ProductPlaceholder class="product-card-image" alt="Select Another Product" />
                    </div>
                    <p v-if="index-1 >= productCount" aria-label="Select Another Product" class="text-rothcoRed">Select Another Product</p>
                    <a v-if="index -1 < productCount" @click.prevent="remove(products[index-1])" class="compare-drawer__body--product-card__remove-btn"  :aria-label="`Remove Drawer Product - ${products[index-1].item_name}`">
                        <TrashIcon class="remove-icon" alt="remove product" />
                    </a>
                </div>

                
            </div>
            <div class="compare-drawer__footer">
                <button @click="showComparisons" class="primary small" aria-label="Compare Drawer Selections">
                    Compare Selections
                    <span aria-hidden="true" class="icon">
                        <CarretsBlack  alt="arrow right" />
                    </span>
                </button>
                <a href="#" aria-label="Clear All Compare Drawer Selections" @click="clear">Clear All</a>
            </div>
        </div>
    
</div>

</template>